<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
	<div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
		<div class="flex items-center gap-1">
			<div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
				<button mat-icon-button color="primary">
				<mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
				</button>
			</div>
			<mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
				<div class="p-4">
				<p>Avisos que envía el sistema a usuarios o correos.
					Elige qué eventos disparan alertas (p. ej., 
					pedido listo, entrega fallida) y por qué canal
					salen. Úsalo para que las personas correctas
					se enteren a tiempo.
				</p>
				</div>
			</mat-menu>
			<h2 class="text-xl font-semibold leading-8 tracking-tight">
			Notificaciones
			</h2>
		</div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Configura las <b>notificaciones</b> que serán enviadas dentro de cada proceso que se ejecute dentro de AVE.
        </div>
      </div>
			<!-- Header -->
			<div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
					<div class="flex shrink-0">
						<!-- Title -->
						<!--<div class="text-3xl font-extrabold tracking-tight">Lista de notificacion</div> -->
					</div>
					<!-- Actions -->
					<div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">

						<app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[0,1]" (selectionFilterApply)="applyStatusFilter()"></app-status-filters>

							<button mat-icon-button color="primary" (click)="openModal()" matTooltip="Nuevo Registro">
									<mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
							</button>
							<button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Glosario">
									<mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
							</button>
							<mat-menu #filterMenu="matMenu">
									<button mat-menu-item [matMenuTriggerFor]="typeMenu">
										<span>Canal</span>
									</button>
									<button mat-menu-item [matMenuTriggerFor]="priorityMenu">
										<span>Prioridad</span>
									</button>
							</mat-menu>
							<mat-menu #typeMenu="matMenu">
									<button mat-menu-item>
											<mat-icon svgIcon="heroicons_outline:envelope" style="color: #9f9f3d"></mat-icon>
											<span>Email</span>
									</button>
									<button mat-menu-item>
											<mat-icon svgIcon="heroicons_outline:envelope" style="color: #008000;"></mat-icon>
											<span>Whatsapp</span>
									</button>
									<button mat-menu-item>
											<mat-icon svgIcon="heroicons_outline:envelope" style="color: #ffa500;"></mat-icon>
											<span>Notificación</span>
									</button>
							</mat-menu>
							<mat-menu #priorityMenu="matMenu">
									<button mat-menu-item>
											<mat-icon svgIcon="heroicons_outline:bell-alert" style="color: #008000;"></mat-icon>
											<span>Enviar ahora</span>
									</button>
									<button mat-menu-item>
											<mat-icon svgIcon="heroicons_outline:bell-snooze" style="color: #9f9f3d"></mat-icon>
											<span>Programado</span>
									</button>
							</mat-menu>
					</div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
							(matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>

							<ng-container matColumnDef="typeId">
									<th mat-header-cell *matHeaderCellDef class="text-center no-padding-cell"></th>
									<td mat-cell *matCellDef="let element" class="text-center no-padding-cell">
											@if(element?.typeId == notificationTypesEnum.NOTIFICATIONS){
											<button matTooltip="Notificación">
													<mat-icon svgIcon="heroicons_outline:envelope" style="color: #ffa500;"></mat-icon>
											</button>
											}@else if (element?.typeId == notificationTypesEnum.WHATSAPP) {
											<button matTooltip="Whatsapp">
													<mat-icon svgIcon="heroicons_outline:envelope" style="color: #008000;"></mat-icon>
											</button>
											}@else {
											<button matTooltip="Email">
													<mat-icon svgIcon="heroicons_outline:envelope" style="color: #9f9f3d"></mat-icon>
											</button>
											}
									</td>
							</ng-container>
								<ng-container matColumnDef="priority">
									<th mat-header-cell *matHeaderCellDef class="text-center no-padding-cell"></th>
									<td mat-cell *matCellDef="let element" class="text-center no-padding-cell">
											@if(element?.date && element?.hour){
											<button matTooltip="Programado">
													<mat-icon svgIcon="heroicons_outline:bell-snooze" style="color: #9f9f3d"></mat-icon>
											</button>
											}@else {
											<button matTooltip="Enviar ahora">
													<mat-icon svgIcon="heroicons_outline:bell-alert" style="color: #008000;"></mat-icon>
											</button>
											}
									</td>
							</ng-container>

							<ng-container matColumnDef="name">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre de Notificación</th>
									<td mat-cell *matCellDef="let element" class="text-sm uppercase">
											{{ element?.name}}
									</td>
							</ng-container>

							<ng-container matColumnDef="company">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Compañía</th>
									<td mat-cell *matCellDef="let element" class="text-sm uppercase">
		
											{{ element?.company?.name}}
									</td>
							</ng-container>

							<ng-container matColumnDef="salesOffice">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Oficina</th>
									<td mat-cell *matCellDef="let element" class="text-sm leading-tight">
											<div *ngIf="getCode(element?.salesOffice) as code">
                        <b class="f-10">{{ code }}</b>
                      </div>
                      {{element?.salesOffice?.name}}
									</td>
							</ng-container>

							<ng-container matColumnDef="statusId">
									<th mat-header-cell *matHeaderCellDef>Estado</th>
									<td mat-cell *matCellDef="let element">
											<mat-slide-toggle class="custom-slide-toggle primary" [checked]="element.statusId == 1"
													[(ngModel)]="element.statusId" [color]="'success'"
													(ngModelChange)="onStatusChange($event, element)">
											</mat-slide-toggle>
									</td>
							</ng-container>
	
							<ng-container matColumnDef="action">
									<th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
									<td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
											<button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
													<mat-icon>more_vert</mat-icon>
											</button>
											<mat-menu #actionMenu="matMenu">
													<button mat-menu-item (click)="openModal(element)">
															<mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
															<span>Editar Registro</span>
													</button>
													<button mat-menu-item (click)="openDeleteDialog(element)">
															<mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
															<span>Eliminar Registro</span>
													</button>
											</mat-menu>
									</td>
							</ng-container>
	
							<tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10 bg-white dark:bg-gray-900"></tr>
							<tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b h-16"></tr>
						</table>
						<div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
						</div>
					</div>
				</div>
	
				<div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
						<mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
								[pageSize]="pageSize"  (page)="changePage($event)"></mat-paginator>
				</div>
			</div>
		</div>
		
		<ng-template #actionModal>
				<h2 mat-dialog-title class="text-lg font-bold mb-1">{{ (this.id == null ? 'Nuevo' : 'Editar')}} Registro</h2>
				<mat-dialog-content class="modal-content">
					 <form #modalForm="ngForm">
						<mat-tab-group>
								<mat-tab label="Datos Generales">
									<div class="pb-2 ">
										<div class="mb-4">
												<div class="flex">
													<mat-icon class="text-blue-400 mr-2 text-sm">info</mat-icon>
													<p class="text-sm text-blue-700">
														Los campos marcados con <strong>**</strong> son obligatorios.													</p>
												</div>
										</div>
										<div class="grid grid-cols-1 md:grid-cols-2 gap-6">
											<mat-form-field appearance="outline" class="w-full">
												<mat-label>Nombre de la notificación*</mat-label>
												<input matInput [(ngModel)]="currentNotification.name" name="name"
													placeholder="Ej: Notificación de pedido listo"
													(input)="currentNotification.name = $event.target.value.toUpperCase()" maxlength="100" required>
												<mat-hint>{{currentNotification.name?.length || 0}}/100</mat-hint>
												<mat-error>El nombre es requerido (mínimo 3 caracteres)</mat-error>
											</mat-form-field>
											
											<mat-form-field appearance="outline" class="w-full">
												<mat-label>Canal de envío*</mat-label>
												<mat-select [(ngModel)]="currentNotification.typeId" name="typeId" required>
													<mat-option *ngFor="let type of listChannel" [value]="type">
														{{ getListTypeLabel(type) }}
													</mat-option>
												</mat-select>
												<mat-error>Selecciona un canal</mat-error>
											</mat-form-field>
											
											<mat-form-field appearance="outline" class="w-full">
												<mat-label>Compañía*</mat-label>
												<mat-select [(ngModel)]="currentNotification.companyId" name="companyId"
													(selectionChange)="onCompanySelectionChange($event.value)" required>
													<mat-option value="">Seleccionar compañía</mat-option>
													<mat-option *ngFor="let company of companyFilterList" [value]="company._id">
														{{ company.name }}
													</mat-option>
												</mat-select>
												<mat-error>Selecciona una compañía</mat-error>
											</mat-form-field>
											<mat-form-field appearance="outline" class="w-full">
												<mat-label>Oficina de venta*</mat-label>
												<mat-select [(ngModel)]="currentNotification.salesOfficeId" name="salesOfficeId"
													[disabled]="!currentNotification.companyId || isLoadingSalesOffices" required>
													<mat-option>
														<ngx-mat-select-search [(ngModel)]="searchOffice" [ngModelOptions]="{standalone: true}"
															(ngModelChange)="changueOptionsSalesOffice($event)" placeholderLabel="Buscar oficina..."
															noEntriesFoundLabel="No se encontraron resultados">
														</ngx-mat-select-search>
													</mat-option>
											
													<mat-option *ngIf="!currentNotification.companyId" disabled>
														Primero selecciona una compañía
													</mat-option>
													<mat-option *ngIf="currentNotification.companyId && isLoadingSalesOffices" disabled>
														Cargando oficinas...
													</mat-option>
													@for (office of listFilterSalesOfficeList(); track office) {
													<mat-option [value]="office._id">
														<b *ngIf="getCode(office) as code">{{ code }} - </b>{{ office.name }}
													</mat-option>
													}
												</mat-select>
												<mat-hint *ngIf="!currentNotification.companyId">
													Selecciona primero una compañía
												</mat-hint>
												<mat-hint *ngIf="currentNotification.companyId && isLoadingSalesOffices">
													Cargando oficinas...
												</mat-hint>
												<mat-error>Selecciona una oficina</mat-error>
											</mat-form-field>
											<mat-form-field appearance="outline" class="w-full">
												<mat-label>Prioridad*</mat-label>
												<mat-select [(ngModel)]="currentNotification.priorityId" name="priorityId" required>
													<mat-option *ngFor="let priority of listPriorityOptions" [value]="priority.code">
														<div class="flex items-center gap-2">
															<div class="w-3 h-3 rounded-full"
																[style.background-color]="priority.code === 0 ? '#10b981' : priority.code === 1 ? '#f59e0b' : '#ef4444'">
															</div>
															{{ priority.name }}
														</div>
													</mat-option>
												</mat-select>
											</mat-form-field>
											<div class="flex flex-col justify-center">
												<div class="flex items-center justify-center gap-3 py-1 px-4 bg-blue-50 rounded-lg border border-blue-200">
													<mat-slide-toggle [(ngModel)]="currentNotification.isForInterestedUser" name="isForInterestedUser"
														color="primary">
													</mat-slide-toggle>
													<div class="flex flex-col justify-center">
														<div class="text-sm font-medium text-gray-900">Usuario interesado</div>
														<div class="text-xs text-gray-600">
															{{ currentNotification.isForInterestedUser ? 'Enviar a usuario interesado' : 'No enviar a usuario interesado' }}
														</div>
													</div>
												</div>
											</div>
											<mat-form-field appearance="outline" class="w-full">
												<mat-label>Tipo*</mat-label>
												<mat-select [(ngModel)]="currentNotification.sourceId" name="sourceId" required>
													<mat-option *ngFor="let source of listSource" [value]="source">
														{{ getListSourceLabel(source) }}
													</mat-option>
												</mat-select>
											</mat-form-field>
											<mat-form-field appearance="outline" class="w-full">
												<mat-label>Frecuencia*</mat-label>
												<mat-select [(ngModel)]="currentNotification.frequency" name="frequency" (selectionChange)="onFrequencyChange()"
													required>
													<mat-option *ngFor="let frequency of listFrequency" [value]="frequency">
														{{ getFrequencyLabel(frequency) }}
													</mat-option>
												</mat-select>
												<mat-hint>Define cuándo se enviará la notificación</mat-hint>
											</mat-form-field>
										</div>
										
										<div *ngIf="currentNotification.frequency === 0 || currentNotification.frequency === 1 || currentNotification.frequency === 3 || currentNotification.frequency === 4"
											class="py-4">
											<div class="border-l-4 border-blue-500 bg-gray-50 p-4 rounded-r-lg mb-4">
												<h3 class="text-md font-semibold text-gray-700 mb-4 flex items-center">
													<mat-icon class="text-blue-500 mr-2">schedule</mat-icon>
													Configuración de Periodo
												</h3>
												<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
													<mat-form-field appearance="outline" class="w-full">
														<mat-label>Fecha de inicio *</mat-label>
														<input matInput [matDatepicker]="initDatePicker" [(ngModel)]="currentNotification.initDate"
															name="initDate" required>
														<mat-datepicker-toggle matIconSuffix [for]="initDatePicker"></mat-datepicker-toggle>
														<mat-datepicker #initDatePicker></mat-datepicker>
														<mat-error>La fecha de inicio es requerida</mat-error>
													</mat-form-field>
													<mat-form-field appearance="outline" class="w-full">
														<mat-label>Fecha de fin</mat-label>
														<input matInput [matDatepicker]="endDatePicker" [(ngModel)]="currentNotification.endDate" name="endDate">
														<mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
														<mat-datepicker #endDatePicker></mat-datepicker>
														<mat-hint>Opcional - sin fecha fin ejecutará indefinidamente</mat-hint>
													</mat-form-field>
													<mat-form-field appearance="outline" class="w-full">
														<mat-label>Hora *</mat-label>
														<mat-icon matSuffix>schedule</mat-icon>
														<input matInput [(ngModel)]="currentNotification.initTime" name="initTime" [ngxTimepicker]="timePicker"
															required>
														<ngx-material-timepicker #timePicker [format]="24"></ngx-material-timepicker>
														<mat-error>La hora es requerida</mat-error>
													</mat-form-field>
												</div>
											</div>
										</div>
										<div *ngIf="currentNotification.frequency === 5 || currentNotification.frequency === 6" class="py-4">
											<div class="border-l-4 border-purple-500 bg-gray-50 p-4 rounded-r-lg mb-4">
												<h3 class="text-md font-semibold text-gray-700 mb-4 flex items-center">
													<mat-icon class="text-purple-500 mr-2">
														{{ currentNotification.frequency === 5 ? 'access_time' : 'timer' }}
													</mat-icon>
													{{ currentNotification.frequency === 5 ? 'Programación por horas' : 'Programación por minutos' }}
												</h3>
												<div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
													<mat-form-field appearance="outline" class="w-full">
														<mat-label>Fecha de Inicio *</mat-label>
														<input matInput
															[matDatepicker]="currentNotification.frequency === 5 ? initDatePicker5 : initDatePicker6"
															[(ngModel)]="currentNotification.initDate" name="initDate" required>
														<mat-datepicker-toggle matIconSuffix
															[for]="currentNotification.frequency === 5 ? initDatePicker5 : initDatePicker6">
														</mat-datepicker-toggle>
														<mat-datepicker #initDatePicker5></mat-datepicker>
														<mat-datepicker #initDatePicker6></mat-datepicker>
														<mat-error *ngIf="!currentNotification.initDate">
															La fecha de inicio es requerida
														</mat-error>
													</mat-form-field>
													<mat-form-field appearance="outline" class="w-full">
														<mat-label>Hora de Inicio *</mat-label>
														<mat-icon matSuffix>schedule</mat-icon>
														<input matInput [(ngModel)]="currentNotification.initTime" name="initTime" placeholder="Hora de inicio"
															[ngxTimepicker]="currentNotification.frequency === 5 ? initTimePicker5 : initTimePicker6" required>
														<ngx-material-timepicker #initTimePicker5 [format]="24"></ngx-material-timepicker>
														<ngx-material-timepicker #initTimePicker6 [format]="24"></ngx-material-timepicker>
														<mat-error *ngIf="!currentNotification.initTime">
															La hora de inicio es requerida
														</mat-error>
													</mat-form-field>
													<mat-form-field appearance="outline" class="w-full">
														<mat-label>{{ getIntervalLabel() }}</mat-label>
														<input matInput type="number" min="1" [(ngModel)]="currentNotification.frequencyInterval"
															name="frequencyInterval" required>
														<mat-hint>{{ getIntervalHint() }}</mat-hint>
														<mat-error
															*ngIf="(!currentNotification.frequencyInterval || currentNotification.frequencyInterval <= 0)">
															El intervalo debe ser mayor a 0
														</mat-error>
													</mat-form-field>
												</div>
												<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
													<mat-form-field appearance="outline" class="w-full">
														<mat-label>Fecha de última notificación</mat-label>
														<input matInput
															[matDatepicker]="currentNotification.frequency === 5 ? lastNotificationDatePicker5 : lastNotificationDatePicker6"
															[(ngModel)]="currentNotification.endDate" name="lastNotificationDate">
														<mat-datepicker-toggle matIconSuffix
															[for]="currentNotification.frequency === 5 ? lastNotificationDatePicker5 : lastNotificationDatePicker6">
														</mat-datepicker-toggle>
														<mat-datepicker #lastNotificationDatePicker5></mat-datepicker>
														<mat-datepicker #lastNotificationDatePicker6></mat-datepicker>
														<mat-hint>Opcional - sin fecha límite ejecutará indefinidamente</mat-hint>
													</mat-form-field>
													<mat-form-field appearance="outline" class="w-full">
														<mat-label>Hora de última notificación</mat-label>
														<mat-icon matSuffix>schedule</mat-icon>
														<input matInput [(ngModel)]="currentNotification.scheduledTime" name="lastNotificationTime"
															placeholder="Hora de última notificación"
															[ngxTimepicker]="currentNotification.frequency === 5 ? lastTimePicker5 : lastTimePicker6">
														<ngx-material-timepicker #lastTimePicker5 [format]="24"></ngx-material-timepicker>
														<ngx-material-timepicker #lastTimePicker6 [format]="24"></ngx-material-timepicker>
														<mat-hint>Opcional - requerida solo si hay fecha límite</mat-hint>
													</mat-form-field>
												</div>
											</div>
										</div>
										<div *ngIf="currentNotification.frequency === 7 || currentNotification.frequency === 9" class="py-4">
											<div class="border-l-4 border-green-500 bg-gray-50 p-4 rounded-r-lg mb-4">
												<h3 class="text-md font-semibold text-gray-700 mb-1 flex items-center">
													<mat-icon class="text-green-600 mr-2">info</mat-icon>
													{{ currentNotification.frequency === 7 ? 'Notificación automática' : 'Notificación por evento' }}
												</h3>
												<p class="text-gray-600">
													{{ currentNotification.frequency === 7 
														? 'Esta notificación se enviará automáticamente cuando se cree el registro. No requiere configuración adicional de fecha y hora.'
														: 'Esta notificación se enviará automáticamente cuando se cree el evento esperado'
													}}
												</p>
											</div>
										</div>
										<div *ngIf="currentNotification.frequency === 8" class="py-4">
											<div class="border-l-4 border-green-500 bg-gray-50 p-4 rounded-r-lg mb-4">
												<h3 class="text-md font-semibold text-gray-700 mb-4 flex items-center">
													<mat-icon class="text-green-500 mr-2">timer</mat-icon>
													Configuración de Periodo
												</h3>
												<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
													<mat-form-field appearance="outline" class="w-full">
														<mat-label>Fecha programada *</mat-label>
														<input matInput [matDatepicker]="scheduledDatePicker" [(ngModel)]="currentNotification.scheduledDate"
															name="scheduledDate" required>
														<mat-datepicker-toggle matIconSuffix [for]="scheduledDatePicker"></mat-datepicker-toggle>
														<mat-datepicker #scheduledDatePicker></mat-datepicker>
														<mat-error>La fecha es requerida</mat-error>
													</mat-form-field>
													<mat-form-field appearance="outline" class="w-full">
														<mat-label>Hora programada *</mat-label>
														<input matInput [(ngModel)]="currentNotification.scheduledTime" name="scheduledTime"
															[ngxTimepicker]="scheduledTimePicker" required>
														<ngx-material-timepicker #scheduledTimePicker [format]="12"></ngx-material-timepicker>
														<mat-error>La hora es requerida</mat-error>
													</mat-form-field>
												</div>
											</div>
										</div>
									</div>
								</mat-tab>
								<mat-tab>
									<ng-template mat-tab-label>
										<span [class.text-gray-400]="!currentNotification.companyId" class="flex items-center gap-2">
											Datos de Envío
											<mat-icon *ngIf="!currentNotification.companyId" class="text-amber-500 enable-tooltip text-sm"
												matTooltip="Selecciona una compañía para habilitar esta sección" matTooltipPosition="above">
												lock
											</mat-icon>
										</span>
									</ng-template>
									<div class="p-6" *ngIf="currentNotification.companyId">
										<mat-form-field appearance="outline" class="w-full mb-6">
											<mat-label>Plantilla*</mat-label>
											<mat-select [(ngModel)]="currentNotification.template" name="template" required>
												<mat-option value="">Sin plantilla**</mat-option>
												<mat-option *ngFor="let template of listTemplate" [value]="template._id">
													<div class="flex justify-between items-center w-full">
														<span>{{ template.name }}</span>
														<mat-chip class="ml-2" [class.bg-green-100]="template.statusId === 1"
															[class.text-green-800]="template.statusId === 1"
															[class.bg-gray-100]="template.statusId !== 1"
															[class.text-gray-600]="template.statusId !== 1">
															{{ getListStatusLabel(template.statusId) }}
														</mat-chip>
													</div>
												</mat-option>
											</mat-select>
											<mat-hint>Selecciona una plantilla para personalizar el contenido</mat-hint>
										</mat-form-field>
										<div class="space-y-4">
											<mat-expansion-panel class="shadow-sm border border-gray-200 rounded-lg">
												<mat-expansion-panel-header class="bg-gray-50">
													<mat-panel-title class="flex items-center gap-2">
														<mat-icon class="text-primary-500">group</mat-icon>
														Destinatarios principales **
														<mat-chip class="ml-2" *ngIf="currentNotification.members?.length">
															({{ currentNotification.members.length }})
														</mat-chip>
													</mat-panel-title>
												</mat-expansion-panel-header>
												<app-table-members [data]="currentNotification" [type]="'members'" [companyList]="this.companyList"
													[companyId]="currentNotification.companyId" (membersChange)="updateFormMembers($event.type, $event.members)">
												</app-table-members>
											</mat-expansion-panel>
											<mat-expansion-panel class="shadow-sm border border-gray-200 rounded-lg">
												<mat-expansion-panel-header class="bg-gray-50">
													<mat-panel-title class="flex items-center gap-2">
														<mat-icon class="text-primary-500">content_copy</mat-icon>
														Destinatarios en copia
														<mat-chip class="ml-2" *ngIf="(currentNotification.copyMembers?.length || 0) > 0">
															({{ currentNotification.copyMembers?.length }})
														</mat-chip>
													</mat-panel-title>
												</mat-expansion-panel-header>
												<app-table-members [data]="currentNotification" [type]="'copyMembers'" [companyList]="this.companyList"
													[companyId]="currentNotification.companyId"
													(membersChange)="updateFormMembers($event.type, $event.members)">
												</app-table-members>
											</mat-expansion-panel>
										</div>
									</div>
									<div *ngIf="!currentNotification.companyId" class="p-12 text-center min-h-96 flex items-center justify-center">
										<div class="max-w-md mx-auto">
											<div class="flex justify-center mb-4">
												<mat-icon class="!text-3xl text-amber-500">lock</mat-icon>
											</div>
											<h3 class="text-xl font-semibold text-gray-900 mb-3">Sección bloqueada</h3>
											<p class="text-gray-600 leading-relaxed">
												Para configurar los datos de envío, primero selecciona una compañía en la pestaña
												<span class="font-medium text-blue-600">"Datos Generales"</span>.
											</p>
										</div>
									</div>
									</mat-tab>
							</mat-tab-group>							
					</form>
				</mat-dialog-content>
				<mat-dialog-actions class="modal-actions flex justify-between">
					<button mat-button mat-dialog-close class="align-left">Cancelar</button>
					<button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!modalForm.valid">Guardar</button>
				</mat-dialog-actions>
		</ng-template>
		<ng-template #deleteDialog let-data>
				<div class="flex items-start space-x-2 mb-4">
						<div class="flex items-center">
								<mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
								style="font-size: 32px;"></mat-icon>
						</div>
						<div class="grid">
								<h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
								<mat-dialog-content class="modal-content mt-0">
										<p>¿Está seguro que desea eliminar el registro?</p>
								</mat-dialog-content>
						</div>
				</div>
				<mat-dialog-actions class="modal-actions flex justify-end">
						<button mat-button mat-dialog-close class="align-left">Conservar</button>
						<button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
				</mat-dialog-actions>
		</ng-template>
	</div>  

	<app-filter (onFilterEvent)="onFilterEvent()" (onCleanEvent)="onClearEvent()">
		<app-configuration-filters
		[setCompanyOnInit]="false"
		[form]="companyEntitiesFormGroup"
		[company]="true"
		></app-configuration-filters>

		<app-configuration-filters
		[setCompanyOnInit]="false"
		[form]="companyEntitiesFormGroup"
		[salesOffice]="true"
		></app-configuration-filters>

		<app-notifications-filters
		[form]="companyEntitiesFormGroup"
		[notificationGroupList]="notificationGroupList"
		[useSelects]="['notificationGroup']"
		></app-notifications-filters>

		<app-notifications-filters
		[form]="companyEntitiesFormGroup"
		[notificationMemberList]="notificationMemberList"
		[useSelects]="['notificationMember']"
		></app-notifications-filters>

	</app-filter>

</mat-sidenav-container>